module.exports = __webpack_public_path__ + "static/img/leftImg.631b48e1.png";